export const filterOperationCodes = (codes, query = '') => {
  const needle = query.trim().toLowerCase();
  if (!needle) return codes;
  return codes.filter((code) => (
    code.code.toLowerCase().includes(needle)
    || code.description.toLowerCase().includes(needle)
    || code.group.toLowerCase().includes(needle)
    || String(code.costType || '').toLowerCase().includes(needle)
  ));
};

export const groupOperationCodes = (codes) => {
  const groups = new Map();
  codes.forEach((code) => {
    const group = code.group || 'Other';
    groups.set(group, [...(groups.get(group) || []), code]);
  });
  return Array.from(groups.entries());
};

